export default {
  props: {
    /**
     * Prevent class attr from being automatically set. This causes visual issue when used within FormInput
     */
    class: {
      type: String,
      default: "",
    },
    name: {
      type: [String, Boolean],
      default: false,
    },
    modelValue: {},
    fields: {
      type: Object,
      default: {},
    },
    /**
     * inline,collapsible,modal
     */
    layout: {
      type: String,
      default: "inline",
    },
    maxFieldsPerRow: {
      type: [Number, String],
      default: 2,
    },
    modalSize: {
      type: String,
      default: "m",
    },
    label: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue"],
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    wrapperElement() {
      if (this.layout !== "modal") {
        return "block";
      }

      return "modal";
    },
    modalTitlePrams() {
      if (typeof this.label === "string") {
        return { subject: this.tu(this.label) };
      }

      return {};
    },
    modalTitle() {
      if (typeof this.label === "string") {
        return "core.form.presetObject.editTitle";
      } else {
        return "core.form.presetObject.editTitleNoSubject";
      }
    },
  },
  methods: {
    enforceObjectSchemaIntegrity(target = {}) {
      if (typeof target !== "object" || !target) {
        target = {};
      }
      let keys = Object.keys(this.fields);
      keys.forEach((key) => {
        if (!target.hasOwnProperty(key)) {
          if (this.fields[key].hasOwnProperty("defaultValue")) {
            target[key] = this.fields[key].defaultValue;
          } else {
            target[key] = null;
          }
        }
      });

      // delete all keys that are not in the schema.
      Object.keys(target).forEach((targetKey) => {
        if (!keys.includes(targetKey)) {
          delete target[targetKey];
        }
      });
      return target;
    },
    enforceValueIntegrity() {
      if (!this.value || typeof this.value !== "object") {
        let res = {};
        res = this.enforceObjectSchemaIntegrity(res);
        this.value = res;
      }
      this.value = this.enforceObjectSchemaIntegrity(this.value);
      // now enforce the schema.
    },
  },
};
